import { ButtonType, EpicIcons } from "@constellation-academy/epic-ui";
import { useFormik } from "formik";
import React, { useContext } from "react";
import { useTranslation } from "@i18n/hooks";
import { filterClass } from "./message-definitions-table-filters.styles";
import { MessageDefinitionsTableFiltersFormState } from "./message-definitions-table-filters.types";
import { Button } from "../../../../../components/button";
import { DefaultTextFieldComponent } from "../../../../../components/DefaultTextInput";
import { ValidatedField } from "../../../../../components/ValidatedField";
import { MessageDefinitionsContext } from "../../../message-definitions.context";

export const MessageDefinitionsTableFilters = () => {
	const { t } = useTranslation("common");
	const { filters, setFilters } = useContext(MessageDefinitionsContext);

	const formik = useFormik<MessageDefinitionsTableFiltersFormState>({
		initialValues: {
			...filters,
		},
		onSubmit: (values: MessageDefinitionsTableFiltersFormState, { setSubmitting }) => {
			setFilters({ filterByTextOpt: values.filterByTextOpt });
			setSubmitting(false);
		},
	});

	const clearForm = () => {
		setFilters({});
		void formik.setFieldValue("filterByTextOpt", "");
		formik.handleSubmit();
	};

	return (
		<div className={filterClass}>
			<ValidatedField<MessageDefinitionsTableFiltersFormState, string>
				name="filterByTextOpt"
				placeholder={t("messageDefinition.filterPlaceholder")}
				component={DefaultTextFieldComponent}
				formikConfig={formik}
			/>

			<Button
				disabled={false}
				type={ButtonType.Reset}
				onClick={clearForm}
				icon={EpicIcons.TIMES}
			/>
			<Button onClick={formik.submitForm} type={ButtonType.Submit} icon={EpicIcons.SEARCH} />
		</div>
	);
};
